let i = 0;

export const FALSE = i++;
export const TRUE = i++;

export const UNDEFINED = i++;
export const NULL = i++;

export const NUMBER = i++;
export const UI8 = i++;
export const NAN = i++;
export const INFINITY = i++;
export const N_INFINITY = i++;
export const ZERO = i++;
export const N_ZERO = i++;

export const BIGINT = i++;
export const BIGUINT = i++;

export const STRING = i++;

export const SYMBOL = i++;

export const ARRAY = i++;
export const BUFFER = i++;
export const DATE = i++;
export const ERROR = i++;
export const MAP = i++;
export const OBJECT = i++;
export const REGEXP = i++;
export const SET = i++;
export const VIEW = i++;

export const IMAGE_DATA = i++;
export const BLOB = i++;
export const FILE = i++;

export const RECURSION = i++;
